import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { header } from "./header";
import { militaryContactsList_template } from "../components/templates/militaryContactsList_template";

declare var ko: any;
declare var page: any;

export class military_contacts extends vnModule_knockoutJS {
    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: militaryContactsList_template;

    protected getModuleName() {
        return "military_contacts";
    }

    buildContent(): Array<Element> {
        this.elementsList = new militaryContactsList_template("list", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Military Contacts");

        return [this.elementsList.build()];
    }

    public fillPage(): void {
        this.elementsList.setIdBrand(this.getBrandId());
        this.filterList();
    }

    public addContact(): void {
        page("/brand/" + this.getBrandId() + "/military-base-guides/contacts/add");
    }

    public viewContact(idContact: number): void {
        page("/brand/" + this.getBrandId() + "/military-base-guides/contacts/view/" + idContact);
    }

    public viewContactOnSite(path: string): void {
        this.openPathOnWebsite(path);
    }

    protected filterList(): void {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url = "/api/brand/" + this.getBrandId() + "/military-base-guides/contacts/get/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.elementsList.setContacts(responseParsed.data);
                let execTime = Math.round((new Date().getTime() - obj.XHRHdl.requestStartTime) / 1000 * 100) / 100;
                obj.elementsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage, execTime);
                obj.viewModel.list.pagination.itemCount(responseParsed.totalCount);
            });
            obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
        };
    }

    protected paginationOnPageClick(): void {
        this.filterList();
    }

    protected filterSimpleOnChange(): void {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(): void {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
    }

    protected listReorder(): void {
        this.filterList();
    }

    public getBrandId(): number {
        return Number(this.getVnAppZone().app.params.idBrand);
    }

    protected openPathOnWebsite(path: string): void {
        if (!path) {
            return;
        }

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const userBrands = this.getVnAppZone().app.loggedUser.user.brands;
        const hostnameParts = window.location.hostname.split(".");
        let urlBegin = "https://";
        let isLocal = false;

        if (hostnameParts.length == 3) {
            if (hostnameParts[0] != "emakicms") {
                urlBegin += hostnameParts[0] + ".";
            } else {
                isLocal = true;
            }
        }

        for (let i = 0; i < userBrands.length; i++) {
            if (userBrands[i].id == idBrand) {
                const url = urlBegin + userBrands[i].domain.replace("www.", "") + (isLocal ? ("." + hostnameParts[2]) : "") + path;
                const element = document.createElement("a");
                element.setAttribute("href", url);
                element.setAttribute("target", "_blank");
                element.style.display = "none";
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
                break;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/military_contacts.ts